import {Component, Input} from '@angular/core';
import {PROFILE_TYPE} from '../../../../../../common/constants';

@Component({
    selector: 'tfl-bo-profile-type-icon',
    template: '<i [ngClass]="profileTypeIconClass"></i>'
})
export class ProfileTypeImageComponent {

    profileTypeIconClass: {} = {};

    @Input('type')
    set _type(type: number) {
        this.profileTypeIconClass = {
            'fa           ': true,
            'fa-2x        ': true,
            'fa-building-o': type === PROFILE_TYPE.CORPORATE,
            'fa-user      ': type === PROFILE_TYPE.PRIVATE
        };
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/profile.type.icon.component.ts